import { useEffect } from "react";

const BASE = "Glories of India Publications";

/**
 * Sets `document.title` for the lifetime of the component that calls it.
 * On unmount the title is reset to the site default so private/admin pages
 * don't inherit a stale public page title.
 *
 * Usage:
 *   useDocumentTitle("Books");                       // → "Books | Glories of India Publications"
 *   useDocumentTitle("About Dinesh Chandra Rawat");  // → "About Dinesh Chandra Rawat | Glories of India Publications"
 *   useDocumentTitle(null);                           // → default site title
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title
      ? `${title} | ${BASE}`
      : `${BASE} | Books & Civilizational Research`;
    return () => { document.title = previous; };
  }, [title]);
}
